import { render } from "./YogaOutroView.vue?vue&type=template&id=bdc991b2&scoped=true"
import script from "./YogaOutroView.vue?vue&type=script&lang=js"
export * from "./YogaOutroView.vue?vue&type=script&lang=js"

import "./YogaOutroView.vue?vue&type=style&index=0&id=bdc991b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc991b2"]])

export default __exports__